import { Component, Inject, OnInit } from '@angular/core';
import { Charge } from '../../../../models/entities/charge';
import { Transaction } from '../../../../models/entities/transactions/transaction';
import { PaymentItem } from '../../../../models/entities/payment-item';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface DepositDetailDialogInput
{
    bankAccountName: string;
    transaction: Transaction;
}

@Component({
    selector: 'app-deposit-detail-dialog', templateUrl: './deposit-detail-dialog.component.html',
})
export class DepositDetailDialogComponent implements OnInit
{
    depositItemsByPayor: {
        payor: string, items: PaymentItem[], total: number
    }[];

    depositAmountByCategory: {
        name: string, amount: number
    }[] = [];

    constructor(@Inject(MAT_DIALOG_DATA) public data: DepositDetailDialogInput) {
    }

    ngOnInit() {
        const depositAmountByCategory = {};
        const depositItemsByPayor = {};
        for (const payorTransaction of this.data.transaction.children) {
            if (typeof depositItemsByPayor[payorTransaction.description] === 'undefined') {
                depositItemsByPayor[payorTransaction.description] = {
                    payor: payorTransaction.description, items: [], total: 0,
                };
            }

            for (const itemTransaction of payorTransaction.children) {
                depositItemsByPayor[payorTransaction.description].items.push(itemTransaction.reference);
                depositItemsByPayor[payorTransaction.description].total += itemTransaction.amount;
                const paymentItem = <PaymentItem>itemTransaction.reference;

                if (paymentItem.payableType === 'App\\Models\\Entities\\Charge') {
                    paymentItem.payable = new Charge({
                        title: itemTransaction.description, category: itemTransaction.category,
                    });
                    if (typeof depositAmountByCategory[itemTransaction.categoryId] === 'undefined') {
                        depositAmountByCategory[itemTransaction.categoryId] = {
                            name: itemTransaction.category.name, amount: 0,
                        };
                    }
                    depositAmountByCategory[itemTransaction.categoryId].amount += itemTransaction.amount;
                } else {
                    if (typeof depositAmountByCategory[-1] === 'undefined') {
                        depositAmountByCategory[-1] = {
                            name: 'Account Credit', amount: 0,
                        };
                    }
                    depositAmountByCategory[-1].amount += itemTransaction.amount;
                }
            }
        }
        this.depositItemsByPayor = Object.values(depositItemsByPayor);
        this.depositAmountByCategory = Object.values(depositAmountByCategory);
    }
}
